// src/pages/FleetPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/FleetPage.css';
import mercedesSprinter from '../assets/sprinter.png';
import mercedesMaybach from '../assets/maybach.png';
import rangeRover from '../assets/rangerover.png';
import cadillacEscalade from '../assets/escalade.png';
import gmcYukon from '../assets/yukon.png';
import chevySuburban from '../assets/suburban.png';

function FleetPage() {
  const vehicles = [
    {
      id: 'mercedes-sprinter',
      name: 'Mercedes Sprinter',
      image: mercedesSprinter,
      category: 'Luxury Van',
      capacity: 'Up to 14 passengers',
      description: 'The ultimate in group luxury travel. Perfect for corporate events, airport transfers, and special occasions.',
      features: ['Luxurious leather seating', 'Advanced climate control', 'Entertainment system', 'Spacious cargo area'],
    },
    {
      id: 'mercedes-maybach',
      name: 'Mercedes Maybach',
      image: mercedesMaybach,
      category: 'Ultra Luxury Sedan',
      capacity: 'Up to 3 passengers',
      description: 'The pinnacle of automotive luxury. Experience unparalleled comfort and sophistication.',
      features: ['Ultra-luxurious interiors', 'Executive rear seating', 'Privacy partition available', 'Premium audio system'],
    },
    {
      id: 'range-rover',
      name: 'Range Rover',
      image: rangeRover,
      category: 'Luxury SUV',
      capacity: 'Up to 4 passengers',
      description: 'Combining British elegance with commanding presence. Perfect for any occasion requiring style and versatility.',
      features: ['Superior comfort', 'Elegant interiors', 'Advanced technology', 'Premium audio systems'],
    },
    {
      id: 'cadillac-escalade',
      name: 'Cadillac Escalade',
      image: cadillacEscalade,
      category: 'Luxury SUV',
      capacity: 'Up to 6 passengers',
      description: 'Bold American luxury at its finest. Make a statement wherever you go.',
      features: ['Commanding presence', 'Spacious seating', 'Advanced safety features', 'High-end infotainment'],
    },
    {
      id: 'gmc-yukon-denali',
      name: 'GMC Yukon Denali',
      image: gmcYukon,
      category: 'Premium SUV',
      capacity: 'Up to 6 passengers',
      description: 'Premium comfort meets robust capability. Ideal for both business and leisure travel.',
      features: ['Premium interior', 'Advanced technology', 'Robust performance', 'Spacious cargo space'],
    },
    {
      id: 'chevy-suburban',
      name: 'Chevy Suburban',
      image: chevySuburban,
      category: 'Full-Size SUV',
      capacity: 'Up to 7 passengers',
      description: 'Spacious and versatile. Perfect for larger groups and extended trips.',
      features: ['Extensive passenger space', 'Advanced connectivity', 'Comfortable interior', 'Versatile seating'],
    },
  ];

  return (
    <div className="fleet-page">
      <section className="fleet-hero">
        <h1 className="fleet-title">Our Fleet</h1>
        <p className="fleet-subtitle">Experience luxury with our premium vehicle collection</p>
      </section>

      <section className="fleet-grid-section">
        <div className="fleet-grid">
          {vehicles.map((vehicle) => (
            <article key={vehicle.id} className="fleet-card">
              <div className="fleet-card-image">
                <img src={vehicle.image} alt={vehicle.name} loading="lazy" />
                <span className="fleet-card-category">{vehicle.category}</span>
              </div>
              <div className="fleet-card-content">
                <h2 className="fleet-card-name">{vehicle.name}</h2>
                <p className="fleet-card-capacity">{vehicle.capacity}</p>
                <p className="fleet-card-description">{vehicle.description}</p>
                <ul className="fleet-card-features">
                  {vehicle.features.map((feature) => (
                    <li key={feature}>{feature}</li>
                  ))}
                </ul>
                <div className="fleet-card-actions">
                  <Link to={`/vehicles/${vehicle.id}`} className="fleet-card-button details">
                    View Details
                  </Link>
                  <Link to={`/booking?vehicle=${encodeURIComponent(vehicle.name)}`} className="fleet-card-button book">
                    Book Now
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="fleet-cta">
        <div className="fleet-cta-content">
          <h2>Not Sure Which Vehicle to Choose?</h2>
          <p>Our team is here to help you select the perfect vehicle for your needs. Contact us for personalized recommendations.</p>
          <a href="tel:2149842522" className="fleet-cta-button">Call (214) 984-2522</a>
        </div>
      </section>
    </div>
  );
}

export default FleetPage;
